import clsx from 'clsx'
import React, { HTMLAttributes, useMemo } from 'react'
import { useFragment } from 'react-relay'
import { graphql } from 'relay-runtime'
import { useAdsFilterMenuParams } from '../FilterMenu/useFilterMenuParams'

import { FullAdPreview_PerformanceSummarizedMetaAd$key } from './__generated__/FullAdPreview_PerformanceSummarizedMetaAd.graphql'

export const FullAdPreview_MetaAd = graphql`
  fragment FullAdPreview_PerformanceSummarizedMetaAd on PerformanceSummarizedMetaAd {
    id
    preview(format: $adPreviewFormat)
  }
`
interface FullAdPreviewProps extends HTMLAttributes<HTMLDivElement> {
  fragmentKey: FullAdPreview_PerformanceSummarizedMetaAd$key
}

export const FullAdPreview = ({
  fragmentKey,
  ...attrs
}: FullAdPreviewProps) => {
  const data = useFragment(FullAdPreview_MetaAd, fragmentKey)
  const [{ previewFormat }] = useAdsFilterMenuParams()

  const amendedIframe = useMemo(() => {
    if (!data.preview) return null

    const parser = new DOMParser()
    const doc = parser.parseFromString(data.preview, 'text/html')
    const iframe = doc.querySelector('iframe')

    if (iframe) {
      iframe.setAttribute('height', '625')
      iframe.setAttribute('width', '350')
    }

    return doc.body.innerHTML 
  }, [data])

  return (
    <div
      className={clsx(
        'relative w-56 flex-none',
        previewFormatHeightClasses[previewFormat || 'MOBILE_FEED_STANDARD']
      )}
    >
      {amendedIframe && (
        <div
          dangerouslySetInnerHTML={{ __html: amendedIframe }}
          className="absolute origin-top-left scale-[67%]"
        />
      )}
    </div>
  )
}

const previewFormatHeightClasses: Record<string, string> = {
  MOBILE_FEED_STANDARD: 'h-[425px]',
  INSTAGRAM_STORY: 'h-96',
}
